export default "__VITE_PUBLIC_ASSET__02e05b1c__"